import { httpClient } from "@/app/client/httpClient";

class MaintenanceService {
  fetchIsInMaintenance() {
    return httpClient.admin.maintenance.$post().then(res => res.result);
  }
}

export const maintenanceService = new MaintenanceService();
